import { asList2ho2pewtsfvv as asList } from '../../../collections/_ArraysJs.mjs';
import { KTypeImpl31l2cx2hil3il as KTypeImpl } from './KTypeImpl.mjs';
import { Companion_getInstance3g08w0on7qs6d as Companion_getInstance } from '../../KTypeProjection.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function createKType(classifier, arguments_0, isMarkedNullable) {
  return new (KTypeImpl())(classifier, asList(arguments_0), isMarkedNullable);
}
function createInvariantKTypeProjection(type) {
  return Companion_getInstance().of(type);
}
//region block: exports
export {
  createInvariantKTypeProjection as createInvariantKTypeProjection3h5364czc0a8w,
  createKType as createKType31ecntyyaay3k,
};
//endregion

//# sourceMappingURL=KTypeHelpers.mjs.map
